<template>
  <Menu as="div" class="relative inline-block text-left w-full md:w-auto">
    <div>
      <MenuButton
        class="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
        :data-as="BaseButton"
      >
        <slot name="dropdown-header-text">
          <div class="flex items-center gap-x-2">
            <span v-if="title">
              {{ title }}
            </span>
            <span class="size-5 text-gray-700 i-mdi-dots-horizontal" aria-hidden="true" />
          </div>
        </slot>
      </MenuButton>
    </div>

    <transition enter-active-class="transition ease-out duration-100" enter-from-class="transform opacity-0 scale-95" enter-to-class="transform opacity-100 scale-100" leave-active-class="transition ease-in duration-75" leave-from-class="transform opacity-100 scale-100" leave-to-class="transform opacity-0 scale-95">
      <MenuItems
        class="absolute z-10 mt-2 w-fit md:w-56 md:min-w-max origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 focus:outline-none"
        :class="{ 'right-0': right }"
      >
        <div class="py-1">
          <slot>
            <MenuItem
              v-for="(item, index) in items"
              :key="`${item.title}-${index}`"
              v-slot="{ active }"
            >
              <slot
                :item="item"
                :active="active"
                :name="`item-${item.title}`"
              >
                <div
                  v-if="item.disabled"
                  class="block px-4 py-2 text-sm text-gray-400 cursor-not-allowed"
                >
                  {{ item.title }}
                </div>
                <a
                  v-else-if="item.href"
                  :href="item.href"
                  :target="item.target"
                  :class="[
                    active ? 'bg-primary-700 text-white outline-none' : 'text-gray-700', 'block px-4 py-2 text-sm'
                  ]"
                >
                  {{ item.title }}
                </a>

                <router-link
                  v-else-if="item.to"
                  :to="item.to"
                  :target="item.target"
                  :class="[
                    active ? 'bg-primary-700 text-white outline-none' : 'text-gray-700', 'block px-4 py-2 text-sm',
                    item.disabled ? 'cursor-not-allowed' : ''
                  ]"
                  @click="$event => item.disabled && $event.preventDefault()"
                >
                  {{ item.title }}
                </router-link>

                <button
                  v-else
                  :class="[active ? 'bg-primary-700 text-white outline-none' : 'text-gray-700', 'block w-full px-4 py-2 text-left text-sm']"
                  @click="item.action"
                >
                  {{ item.title }}
                </button>
              </slot>
            </MenuItem>
          </slot>
        </div>
      </MenuItems>
    </transition>
  </Menu>
</template>

<script setup lang="ts">
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue'
import { PropType } from 'vue'
import BaseButton from './BaseButton.vue'

defineProps({
  right: {
    type: Boolean,
    default: false
  },
  title: {
    type: String,
    required: false,
    default: 'Select an option'
  },
  items: {
    type: Array as PropType<{
      title: string,
      href?: string,
      to?: Object,
      target?: string,
      disabled?: boolean,
      action?: () => void
    }[]>,
    default: () => []
  }
})
</script>
